import React, { useContext, useEffect, useState } from 'react';
import { Box, ButtonGroup, Heading } from '@chakra-ui/react';
import LinkButton from '../../../components/custom/LinkButton';
import { useParams } from 'react-router-dom';
import { UseApi } from '../../../libraries/UseApi';
import { UserInfoContext } from '../../../provider/UserInfoProvider';
import { UseMessage } from '../../../libraries/UseMessage';
import Loading from '../../../components/common/Loading';
import AddTechnologyForm from '../../../components/forms/technology/AddTechnologyForm';

export default function EditTechnology() {
    const { id } = useParams();
    const { getApi } = UseApi();
    const {token} = useContext(UserInfoContext);
    const {Message} = UseMessage();

    const [isProcessing, setIsProcessing] = useState(false);
    const [technology, setTechnology] = useState({});

    useEffect(() => {
        getTechnology(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const getTechnology = (id) => {
        // 処置中チェック
        if (isProcessing) {
            // 処理中の場合、以降の処理を実施しない
            return;
        }
        // 処理中フラグをONにする
        setIsProcessing(true);

        getApi(
            `${process.env.REACT_APP_API_URL}/technology/${id}`, {}, { token: token },
            (response) => {
                // 成功時
                if (response.isSuccess === false) {
                    // error
                    alert(Message.Common.ERROR);
                    // 処理中フラグを元に戻す
                    setIsProcessing(false);
                    return;
                }

                setTechnology(response.data);
                // 処理中フラグを元に戻す
                setIsProcessing(false);
            },
            () => {
                // 異常時
                // 処理中フラグをOFFにする
                setIsProcessing(false);
            }
        );
    }

    return (
        <>
            <div className='admin-page-header'>
                <Heading as='h2' size='2xl' noOfLines={1}>
                    技術編集
                </Heading>
                <ButtonGroup gap={2}>
                    <LinkButton buttonText={'戻る'} buttonUrl={'/technologies'}/>
                </ButtonGroup>
            </div>
            <Box className='admin-box'>
                {isProcessing
                    ? <Loading />
                    : <AddTechnologyForm technology={technology} isEdit={true} />
                }
            </Box>
        </>   
    )
}
